var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70654 3.07568C7.95967 3.07568 8.16887 3.26379 8.20198 3.50784L8.20654 3.57568V12.6542C8.20654 12.9303 7.98269 13.1542 7.70654 13.1542C7.45341 13.1542 7.24422 12.9661 7.21111 12.722L7.20654 12.6542V3.57568C7.20654 3.29954 7.4304 3.07568 7.70654 3.07568Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.35194 3.2227C7.52962 3.0442 7.80846 3.02797 8.00453 3.17402L8.06068 3.2227L10.7792 5.95381C10.974 6.14953 10.9733 6.46611 10.7776 6.66092C10.5996 6.83802 10.3218 6.85352 10.1264 6.70783L10.0705 6.65929L7.70616 4.28388L5.34216 6.65929C5.16506 6.83721 4.88732 6.85399 4.69125 6.7092L4.63506 6.66092C4.45714 6.48382 4.44036 6.20608 4.58514 6.01001L4.63342 5.95381L7.35194 3.2227Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowMessage);
export default __webpack_public_path__ + "static/media/iconArrowMessage.958b14c621c342e6dd2f1c2ee3ff0d06.svg";
export { ForwardRef as ReactComponent };